<template>
    <div>
        <div class="container" v-if="deal.savings">
            <div class="row">
                <div class="col-12 text-center">
                    <h2 class=" my-5">Congratulations {{ user.first_name }}!</h2>
                    <p>MySwitchPro has scanned all our energy supplier partners and their tariffs and have found the best plan for you,
                        based on the information that you have provided,
                        saving you most money on your energy bills when you switch from your current supplier.</p>
                    <h4 class="my-4 my-lg-5">Your New Best Deal!</h4>
                </div>
                <div class="col-12 col-lg-10 mx-auto" >
                    <hr/>
                    <deal-summary :deal="deal" />
                    <hr/>
                </div>
            </div>
            <div class="row pt-4">
                <div class="col-12 tariff-summary">
                    <p class="text-center mb-4" v-if="currentExitFee">Please note that you may be subject to &pound;{{(currentExitFee)}} exit fees from your current energy supplier.</p>
                    <h4 class="text-center">Your New Tariff Summary:</h4>
                    <deal-tariff-summary :deal="deal" />
                    <hr class="mt-5">
                </div>
            </div>
            <div class="row mb-5 mt-3">
                <div class="col-6 col-sm-6 col-lg-2 mx-auto mx-lg-0 mt-0 mt-lg-4 ">
                    <router-link :to="{name: 'SetupUsage'}" class="btn btn-outline-primary btn-lg btn-block" >
                        <i class="fa fa-arrow-left mr-3"></i> Back
                    </router-link>
                </div>
                <div class="col-12 col-lg-4  offset-lg-2 mt-4 " >
                    
                    <button class="btn btn-success btn-success-gradient btn-lg btn-block" v-if="!$store.getters['auth/hasDirectDebit']"
                            @click="$router.push({name: 'SetupDebit'})">
                        <span>Let’s do it!</span>
                        
                        <i class="fa fa-long-arrow-right float-right mt-1"></i>
                    </button>
                    <button class="btn btn-success btn-success-gradient btn-lg btn-block" v-if="$store.getters['auth/hasDirectDebit']"
                            @click="confirmSwitch">
                        <span >Confirm and switch!</span>
                        <i class="fa fa-long-arrow-right float-right mt-1"></i>
                    </button>
            
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <div class="row">
                <div class="col-12 col-sm-8 mx-auto text-center p-5">
                    <h1 class="text-muted">Finding the best deal...</h1>
                    <div class="progress mt-4">
                        <div class="progress-bar bg-success progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '@/store/index'
import api from "@/utils/api"
import DealSummary from "@/components/setup/DealSummary";
import DealTariffSummary from "@/components/setup/DealTariffSummary";
import {EventBus, events} from "@/utils/event-bus";

export default {
    name: "Deal",
    components: {DealTariffSummary, DealSummary},
    data: function () {
        return {
            deal: {
                product: {
                    supplier: {}
                },
                tariff: {},
                savings: null
            },
            currentExitFee: null,
        }
    },
    methods: {
        setDeal: function (deal) {
            this.deal = deal
            this.fetchLatestPropertyExitFee()
        },
        fetchLatestPropertyExitFee() {
            let that = this;
          api.property('latest').then(result => {
              api.propertyTariff(result.data.data.id).then((result) => {
                  let product = result.data.data.d;
                  if(product){
                      that.currentExitFee = product.tariff.exit_fee_elec + product.tariff.exit_fee_gas
                  }
                  product = result.data.data.e;
                  if(product){
                      that.currentExitFee = product.tariff.exit_fee_elec
                  }
                  product = result.data.data.g;
                  if(product){
                      that.currentExitFee = product.tariff.exit_fee_gas
                  }
              })
          })
        },
        confirmSwitch: function (){
            let that = this;
            api.confirmSwitch(this.deal.code).then(() => {
                that.$router.push({name: 'SetupComplete'})
            }).catch(() => {
                that.$toast.error('Problem with confirming your switch!')
            })
        },
        handleWorthlessRecommendation: function () {
            this.$store.commit('auth/setWorthlessDeal', true)
            if (this.$store.getters['auth/hasDirectDebit']) {
                this.$router.push({name: 'SetupComplete'})
            } else {
                this.$router.push({name: 'SetupDebit'})
            }
        }
    },
    computed: {
        ...mapGetters('auth', [
            'user'
        ]),
        hasExitFee: function (){
            return (this.deal.tariff.exit_fee_elec && this.deal.tariff.exit_fee_elec > 0)
                || (this.deal.tariff.exit_fee_gas && this.deal.tariff.exit_fee_gas > 0)
        }
    },
    mounted() {
        let that = this;
        let run = function (){
            that.$store.commit('setup/setEstimate', null)
            that.$store.commit('auth/setWorthlessDeal', null)
            if (that.$store.getters['auth/recommendationCode']) {
                api.getRecommendation(that.$store.getters['auth/recommendationCode']).then(response => {
                    if(response.data.data.worthless){
                        that.handleWorthlessRecommendation();
                        return;
                    }
                    that.setDeal(response.data.data)
                })
            } else {
                api.storeSurvey(that.$store.getters['setup/choice']).then(response => {
                    let data = response.data.data;
                    store.commit('auth/recommendationCode', data.code);
                    if(data.worthless){
                        store.commit('auth/setWorthlessDeal', true);
                    } else {
                        store.commit('setup/setEstimate', data.savings);
                    }
                    store.commit('auth/setIsFresh', false)
                    if(response.data.data.worthless){
                        that.handleWorthlessRecommendation();
                        return;
                    }
                    that.setDeal(response.data.data)
                })
            }
        }
        
        setTimeout(run, 2000);
    },
    beforeRouteEnter: function (to, from, next) {
        
        if (store.getters['auth/isGuest']) {
            store.commit('setup/setEstimate', null)
            store.commit('auth/setWorthlessDeal', null)
            
            api.storeSurvey(store.getters['setup/choice']).then(response => {
                let data = response.data.data;
                store.commit('auth/recommendationCode', data.code);
                if(data.worthless){
                    store.commit('auth/setWorthlessDeal', true);
                } else {
                    store.commit('setup/setEstimate', data.savings);
                }
                store.commit('auth/setIsFresh', false)
                next({name: 'Register'});
            }).catch(() => {
                EventBus.$emit(events.survey.error)
            })
        } else {
            next()
        }
    },
    
    
}
</script>

<style scoped lang="scss">
@import "../../sass/base";

.tariff-summary {
    p {
        margin: 0;
    }
    
    .row {
        line-height: 24px;
    }
}
</style>
